import { render, staticRenderFns } from "./kw_list_default.vue?vue&type=template&id=95c8b8fa&"
import script from "./kw_list_default.vue?vue&type=script&lang=js&"
export * from "./kw_list_default.vue?vue&type=script&lang=js&"
import style0 from "./kw_list_default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "kw_list_default.vue"
export default component.exports